var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f5f5f5","height":"100%"}},[_c('div',{staticClass:"pa-5"},[_c('v-container',{staticClass:"my-5"},[_c('div',{staticClass:"logs"},_vm._l((_vm.logs),function(log,i){return _c('div',{key:i},[_vm._v(" "+_vm._s(log)+" ")])}),0)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }